import script from "./GuangFa.vue?vue&type=script&lang=ts&setup=true"
export * from "./GuangFa.vue?vue&type=script&lang=ts&setup=true"

import "./GuangFa.vue?vue&type=style&index=0&id=48bddfac&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48bddfac"]])

export default __exports__